import Toast                                             from "_common/toast";
import { getDeviceType }                                 from "_common/utils";
import { TELEGRAM_BOT_MOBILE_URL, TELEGRAM_BOT_WEB_URL } from "_config/index";

import Presentation from "./presentation";

const component = props => {

	const {
		isMobile
	} = props;

	const platform = getDeviceType ();

	const isWebview = () => {
		if ( platform === "android" || platform === "ios" )
			return true;

		return false;
	};

	const onLinkClick = id => {

		let url = TELEGRAM_BOT_WEB_URL;

		if ( isMobile || isWebview () )
			url = TELEGRAM_BOT_MOBILE_URL;

		switch ( id ) {
			case "faq": {
				Toast.info ( "FAQ Support will be added soon." );
				break;
			}

			case "support": {
				handleOpenLink ( url );
				break;
			}

			default:
				break;

		}
	};

	const handleOpenLink = url => {
		if ( platform === "android" ) {
			window?.Android?.openBrowser ( url );

			return;
		}

		if ( platform === "ios" ) {
			// Send a message with arguments to the native iOS code
			let dataToSend = {
				action    : "openBrowser", // action is always name of the JS function
				arguments : {
					url
				}
			};

			window?.webkit?.messageHandlers?.ios_handler?.postMessage ( JSON.stringify ( dataToSend ) );

			return;
		}
		window.open ( url, "_blank" );
	};

	return (
		<Presentation
			{ ...props }
			onLinkClick = { onLinkClick }
		/>
	);
};

export default component;

